import React, { Component } from 'react';

import './styles.scss';

export default class SortTeams extends Component {
    constructor(props){
        super(props);
    };

    // State
    state = {
        collapsed: true,
        options: [
          { name: 'A-Z', selected: true, function: (a,b) => a.title.localeCompare(b.title) },
          { name: 'Z-A', selected: false, function: (a,b) => b.title.localeCompare(a.title) },
          { name: 'Oldest', selected: false, function: (a,b) => a.id - b.id },
          { name: 'Latest', selected: false, function: (a,b) => b.id - a.id }
        ]
    }
    
    // Functions
    toggleDropdown() {
      var drop = document.getElementById('dropdown');
      var arr = document.getElementById('arrow');
      var collapsed = !this.state.collapsed;

      if(collapsed){
        drop.classList.remove('dropdown-content-open');
        arr.classList.remove('dropdown-arrow-rotate');
      } else {
        drop.classList.add('dropdown-content-open');
        arr.classList.add('dropdown-arrow-rotate');
      }

      this.setState({
          collapsed: collapsed
      });
    }

    selectOption(index) {
      var optionsCopy = [...this.state.options];
      optionsCopy.forEach((option) => option.selected = false);
      optionsCopy[index].selected = true;

      // sets menu selected state
      this.setState({
        options: optionsCopy
      });
      // sets tree sort state
      if(this.props.setSortFunction) {
        this.props.setSortFunction(this.state.options[index].function);
      }
    }

    // Render
    render(){
        return(
          <div className='flex-child'>
            <div className="wrapper">
              <div className="dropdown-container" onClick={() => this.toggleDropdown()}>
                <span className="dropdown-title">Sort by:</span>
                <div id="arrow" className="dropdown-arrow">
                  <i className="material-icons-round">expand_more</i>
                </div>
              </div>
              <div id="dropdown" className="dropdown-content">
                {this.state.options.map((option, index) => {
                  return (
                    <div key={index} className="dropdown-item" onClick={() => this.selectOption(index)}>
                      <span className="item-title">{option.name}</span>
                      <div className="radio-button">
                        {option.selected ? 
                          <i className="material-icons md-15">radio_button_checked</i> : 
                          <i className="material-icons md-15">radio_button_unchecked</i>
                        }
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
    }
}
